'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData$002dCredit$002dNote$002dForm from "./app.data.-App-Document-Data-Credit-Note-Form.js";
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData$002dInvoice$0024$0024anon$00241 from "./app.data.-App-Document-Data-Invoice$$anon$1.js";
import * as $j_app$002edata$002e$002dApp$002dDocument$002dOrganization$002dInfo$002dForm$0024 from "./app.data.-App-Document-Organization-Info-Form$.js";
import * as $j_app$002edata$002e$002dDocumentary$002dCredit$002dData$0024package$0024$002dDocumentary$002dCredit$002dNumber$002dForm$0024 from "./app.data.-Documentary-Credit-Data$package$-Documentary-Credit-Number-Form$.js";
import * as $j_app$002edata$002e$002dDocumentary$002dCredit$002dForm$002dData from "./app.data.-Documentary-Credit-Form-Data.js";
import * as $j_app$002edata$002e$002dIncoterm$002dData$002dForm from "./app.data.-Incoterm-Data-Form.js";
import * as $j_app$002edata$002e$002dInvoice$002dLine$002dItem$0024 from "./app.data.-Invoice-Line-Item$.js";
import * as $j_app$002edata$002e$002dPurchase$002dOrder$002dContract$002dData$0024package$0024$002dPurchase$002dOrder$002dNumber$002dForm$0024 from "./app.data.-Purchase-Order-Contract-Data$package$-Purchase-Order-Number-Form$.js";
import * as $j_app$002edata$002e$002dPurchase$002dOrder$002dReference$002dForm from "./app.data.-Purchase-Order-Reference-Form.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dAdditional$002dCredit$0024 from "./app.data.data_point_types$package$-Additional-Credit$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDocument$002dNumber$002dForm$0024 from "./app.data.data_point_types$package$-Document-Number-Form$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dIncoterm$0024 from "./app.data.data_point_types$package$-Incoterm$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dIncoterm$002dLocation$002dForm$0024 from "./app.data.data_point_types$package$-Incoterm-Location-Form$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dInvoice$002dNumber$002dForm$0024 from "./app.data.data_point_types$package$-Invoice-Number-Form$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dIssuing$002dBank$002dForm$0024 from "./app.data.data_point_types$package$-Issuing-Bank-Form$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dOrigin$002dOf$002dGoods$0024 from "./app.data.data_point_types$package$-Origin-Of-Goods$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPlace$002dOf$002dDelivery$0024 from "./app.data.data_point_types$package$-Place-Of-Delivery$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPlace$002dOf$002dDischarge$0024 from "./app.data.data_point_types$package$-Place-Of-Discharge$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPlace$002dOf$002dLoading$0024 from "./app.data.data_point_types$package$-Place-Of-Loading$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPlace$002dOf$002dReceipt$0024 from "./app.data.data_point_types$package$-Place-Of-Receipt$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dTransport$002dDocument$002dNumber$0024 from "./app.data.data_point_types$package$-Transport-Document-Number$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataInvoice(number, issuer, recipient, paymentDetails, issueDate, lineItems, originOfGoods, manufacturer, documentaryCredit, currency, paymentTerms, usuance, placeOfReceipt, placeOfLoading, placeOfDelivery, placeOfDischarge, incoterm, vesselOrFlightNumber, freightCost, insuranceNumber, insuranceCost, shipmentDate, importer, consignee, dueDate, shippingMarks, purchaseOrderReference, harmonizedSystemCode, transportDocumentNumber, voyage, preCarriageVesselOrFlightNumber, measurements, containerNumber, truckNumber) {
  this.Bs = null;
  this.yV = null;
  this.F8 = null;
  this.Lo = null;
  this.Br = null;
  this.F1 = null;
  this.F2 = null;
  this.Lm = null;
  this.EZ = null;
  this.EY = null;
  this.Lp = null;
  this.Lu = null;
  this.F6 = null;
  this.F5 = null;
  this.F3 = null;
  this.F4 = null;
  this.F0 = null;
  this.Lv = null;
  this.Lh = null;
  this.Ll = null;
  this.Lk = null;
  this.Lr = null;
  this.Lj = null;
  this.Le = null;
  this.Lg = null;
  this.Ls = null;
  this.F7 = null;
  this.Li = null;
  this.F9 = null;
  this.Lw = null;
  this.Lq = null;
  this.Ln = null;
  this.Lf = null;
  this.Lt = null;
  this.Bs = number;
  this.yV = issuer;
  this.F8 = recipient;
  this.Lo = paymentDetails;
  this.Br = issueDate;
  this.F1 = lineItems;
  this.F2 = originOfGoods;
  this.Lm = manufacturer;
  this.EZ = documentaryCredit;
  this.EY = currency;
  this.Lp = paymentTerms;
  this.Lu = usuance;
  this.F6 = placeOfReceipt;
  this.F5 = placeOfLoading;
  this.F3 = placeOfDelivery;
  this.F4 = placeOfDischarge;
  this.F0 = incoterm;
  this.Lv = vesselOrFlightNumber;
  this.Lh = freightCost;
  this.Ll = insuranceNumber;
  this.Lk = insuranceCost;
  this.Lr = shipmentDate;
  this.Lj = importer;
  this.Le = consignee;
  this.Lg = dueDate;
  this.Ls = shippingMarks;
  this.F7 = purchaseOrderReference;
  this.Li = harmonizedSystemCode;
  this.F9 = transportDocumentNumber;
  this.Lw = voyage;
  this.Lq = preCarriageVesselOrFlightNumber;
  this.Ln = measurements;
  this.Lf = containerNumber;
  this.Lt = truckNumber;
}
export { $c_Lapp_data_AppDocumentDataInvoice as $c_Lapp_data_AppDocumentDataInvoice };
$p = $c_Lapp_data_AppDocumentDataInvoice.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentDataInvoice;
/** @constructor */
function $h_Lapp_data_AppDocumentDataInvoice() {
}
export { $h_Lapp_data_AppDocumentDataInvoice as $h_Lapp_data_AppDocumentDataInvoice };
$h_Lapp_data_AppDocumentDataInvoice.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentDataInvoice)) {
    if ((this.Bs === x$0.Bs)) {
      var x = this.yV;
      var x$2 = x$0.yV;
      var $x_32 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_32 = false;
    }
    if ($x_32) {
      var x$3 = this.F8;
      var x$4 = x$0.F8;
      var $x_31 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_31 = false;
    }
    if ($x_31) {
      var x$5 = this.Lo;
      var x$6 = x$0.Lo;
      var $x_30 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_30 = false;
    }
    if ($x_30) {
      var x$7 = this.Br;
      var x$8 = x$0.Br;
      var $x_29 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_29 = false;
    }
    if ($x_29) {
      var x$9 = this.F1;
      var x$10 = x$0.F1;
      var $x_28 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_28 = false;
    }
    if ($x_28) {
      var x$11 = this.F2;
      var x$12 = x$0.F2;
      var $x_27 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_27 = false;
    }
    if ($x_27) {
      var x$13 = this.Lm;
      var x$14 = x$0.Lm;
      var $x_26 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_26 = false;
    }
    if ($x_26) {
      var x$15 = this.EZ;
      var x$16 = x$0.EZ;
      var $x_25 = ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      var $x_25 = false;
    }
    if ($x_25) {
      var x$17 = this.EY;
      var x$18 = x$0.EY;
      var $x_24 = ((x$17 === null) ? (x$18 === null) : x$17.f(x$18));
    } else {
      var $x_24 = false;
    }
    if ($x_24) {
      var x$19 = this.Lp;
      var x$20 = x$0.Lp;
      var $x_23 = ((x$19 === null) ? (x$20 === null) : x$19.f(x$20));
    } else {
      var $x_23 = false;
    }
    if ($x_23) {
      var x$21 = this.Lu;
      var x$22 = x$0.Lu;
      var $x_22 = ((x$21 === null) ? (x$22 === null) : x$21.f(x$22));
    } else {
      var $x_22 = false;
    }
    if ($x_22) {
      var x$23 = this.F6;
      var x$24 = x$0.F6;
      var $x_21 = ((x$23 === null) ? (x$24 === null) : x$23.f(x$24));
    } else {
      var $x_21 = false;
    }
    if ($x_21) {
      var x$25 = this.F5;
      var x$26 = x$0.F5;
      var $x_20 = ((x$25 === null) ? (x$26 === null) : x$25.f(x$26));
    } else {
      var $x_20 = false;
    }
    if ($x_20) {
      var x$27 = this.F3;
      var x$28 = x$0.F3;
      var $x_19 = ((x$27 === null) ? (x$28 === null) : x$27.f(x$28));
    } else {
      var $x_19 = false;
    }
    if ($x_19) {
      var x$29 = this.F4;
      var x$30 = x$0.F4;
      var $x_18 = ((x$29 === null) ? (x$30 === null) : x$29.f(x$30));
    } else {
      var $x_18 = false;
    }
    if ($x_18) {
      var x$31 = this.F0;
      var x$32 = x$0.F0;
      var $x_17 = ((x$31 === null) ? (x$32 === null) : x$31.f(x$32));
    } else {
      var $x_17 = false;
    }
    if ($x_17) {
      var x$33 = this.Lv;
      var x$34 = x$0.Lv;
      var $x_16 = ((x$33 === null) ? (x$34 === null) : x$33.f(x$34));
    } else {
      var $x_16 = false;
    }
    if ($x_16) {
      var x$35 = this.Lh;
      var x$36 = x$0.Lh;
      var $x_15 = ((x$35 === null) ? (x$36 === null) : x$35.f(x$36));
    } else {
      var $x_15 = false;
    }
    if ($x_15) {
      var x$37 = this.Ll;
      var x$38 = x$0.Ll;
      var $x_14 = ((x$37 === null) ? (x$38 === null) : x$37.f(x$38));
    } else {
      var $x_14 = false;
    }
    if ($x_14) {
      var x$39 = this.Lk;
      var x$40 = x$0.Lk;
      var $x_13 = ((x$39 === null) ? (x$40 === null) : x$39.f(x$40));
    } else {
      var $x_13 = false;
    }
    if ($x_13) {
      var x$41 = this.Lr;
      var x$42 = x$0.Lr;
      var $x_12 = ((x$41 === null) ? (x$42 === null) : x$41.f(x$42));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$43 = this.Lj;
      var x$44 = x$0.Lj;
      var $x_11 = ((x$43 === null) ? (x$44 === null) : x$43.f(x$44));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$45 = this.Le;
      var x$46 = x$0.Le;
      var $x_10 = ((x$45 === null) ? (x$46 === null) : x$45.f(x$46));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$47 = this.Lg;
      var x$48 = x$0.Lg;
      var $x_9 = ((x$47 === null) ? (x$48 === null) : x$47.f(x$48));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$49 = this.Ls;
      var x$50 = x$0.Ls;
      var $x_8 = ((x$49 === null) ? (x$50 === null) : x$49.f(x$50));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$51 = this.F7;
      var x$52 = x$0.F7;
      var $x_7 = ((x$51 === null) ? (x$52 === null) : x$51.f(x$52));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$53 = this.Li;
      var x$54 = x$0.Li;
      var $x_6 = ((x$53 === null) ? (x$54 === null) : x$53.f(x$54));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$55 = this.F9;
      var x$56 = x$0.F9;
      var $x_5 = ((x$55 === null) ? (x$56 === null) : x$55.f(x$56));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$57 = this.Lw;
      var x$58 = x$0.Lw;
      var $x_4 = ((x$57 === null) ? (x$58 === null) : x$57.f(x$58));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$59 = this.Lq;
      var x$60 = x$0.Lq;
      var $x_3 = ((x$59 === null) ? (x$60 === null) : x$59.f(x$60));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$61 = this.Ln;
      var x$62 = x$0.Ln;
      var $x_2 = ((x$61 === null) ? (x$62 === null) : x$61.f(x$62));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$63 = this.Lf;
      var x$64 = x$0.Lf;
      var $x_1 = ((x$63 === null) ? (x$64 === null) : x$63.f(x$64));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$65 = this.Lt;
      var x$66 = x$0.Lt;
      return ((x$65 === null) ? (x$66 === null) : x$65.f(x$66));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 34;
});
$p.t = (function() {
  return "AppDocumentDataInvoice";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.Bs;
      break;
    }
    case 1: {
      return this.yV;
      break;
    }
    case 2: {
      return this.F8;
      break;
    }
    case 3: {
      return this.Lo;
      break;
    }
    case 4: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(this.Br);
      break;
    }
    case 5: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector(this.F1);
      break;
    }
    case 6: {
      return this.F2;
      break;
    }
    case 7: {
      return this.Lm;
      break;
    }
    case 8: {
      return this.EZ;
      break;
    }
    case 9: {
      return this.EY;
      break;
    }
    case 10: {
      return this.Lp;
      break;
    }
    case 11: {
      return this.Lu;
      break;
    }
    case 12: {
      return this.F6;
      break;
    }
    case 13: {
      return this.F5;
      break;
    }
    case 14: {
      return this.F3;
      break;
    }
    case 15: {
      return this.F4;
      break;
    }
    case 16: {
      return this.F0;
      break;
    }
    case 17: {
      return this.Lv;
      break;
    }
    case 18: {
      return this.Lh;
      break;
    }
    case 19: {
      return this.Ll;
      break;
    }
    case 20: {
      return this.Lk;
      break;
    }
    case 21: {
      return this.Lr;
      break;
    }
    case 22: {
      return this.Lj;
      break;
    }
    case 23: {
      return this.Le;
      break;
    }
    case 24: {
      return this.Lg;
      break;
    }
    case 25: {
      return this.Ls;
      break;
    }
    case 26: {
      return this.F7;
      break;
    }
    case 27: {
      return this.Li;
      break;
    }
    case 28: {
      return this.F9;
      break;
    }
    case 29: {
      return this.Lw;
      break;
    }
    case 30: {
      return this.Lq;
      break;
    }
    case 31: {
      return this.Ln;
      break;
    }
    case 32: {
      return this.Lf;
      break;
    }
    case 33: {
      return this.Lt;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "number";
      break;
    }
    case 1: {
      return "issuer";
      break;
    }
    case 2: {
      return "recipient";
      break;
    }
    case 3: {
      return "paymentDetails";
      break;
    }
    case 4: {
      return "issueDate";
      break;
    }
    case 5: {
      return "lineItems";
      break;
    }
    case 6: {
      return "originOfGoods";
      break;
    }
    case 7: {
      return "manufacturer";
      break;
    }
    case 8: {
      return "documentaryCredit";
      break;
    }
    case 9: {
      return "currency";
      break;
    }
    case 10: {
      return "paymentTerms";
      break;
    }
    case 11: {
      return "usuance";
      break;
    }
    case 12: {
      return "placeOfReceipt";
      break;
    }
    case 13: {
      return "placeOfLoading";
      break;
    }
    case 14: {
      return "placeOfDelivery";
      break;
    }
    case 15: {
      return "placeOfDischarge";
      break;
    }
    case 16: {
      return "incoterm";
      break;
    }
    case 17: {
      return "vesselOrFlightNumber";
      break;
    }
    case 18: {
      return "freightCost";
      break;
    }
    case 19: {
      return "insuranceNumber";
      break;
    }
    case 20: {
      return "insuranceCost";
      break;
    }
    case 21: {
      return "shipmentDate";
      break;
    }
    case 22: {
      return "importer";
      break;
    }
    case 23: {
      return "consignee";
      break;
    }
    case 24: {
      return "dueDate";
      break;
    }
    case 25: {
      return "shippingMarks";
      break;
    }
    case 26: {
      return "purchaseOrderReference";
      break;
    }
    case 27: {
      return "harmonizedSystemCode";
      break;
    }
    case 28: {
      return "transportDocumentNumber";
      break;
    }
    case 29: {
      return "voyage";
      break;
    }
    case 30: {
      return "preCarriageVesselOrFlightNumber";
      break;
    }
    case 31: {
      return "measurements";
      break;
    }
    case 32: {
      return "containerNumber";
      break;
    }
    case 33: {
      return "truckNumber";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.yy = (function() {
  return this.Bs;
});
$p.Wh = (function() {
  return this.yV;
});
$p.bXM = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$();
  return new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dInvoice$0024$0024anon$00241.$c_Lapp_data_AppDocumentDataInvoice$$anon$1().bwN(this);
});
$p.bXH = (function(now, createdAt) {
  var TransformerInto_this = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_dsl_TransformerInto(this, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_dsl_TransformerDefinition(($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$())));
  var TransformerInto_this$2 = TransformerInto_this.hw($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__empty__Lalleycats_Empty__Lalleycats_Empty($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDocument$002dNumber$002dForm$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lalleycats_EmptyInstances1__monoidIsEmpty__Lcats_kernel_Monoid__Lalleycats_Empty($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Empty$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_kernel_instances_string_package$().aK)).aP());
  var this$10 = this.yV;
  var TransformerInto_this$3 = TransformerInto_this$2.hw($j_app$002edata$002e$002dApp$002dDocument$002dOrganization$002dInfo$002dForm$0024.$m_Lapp_data_AppDocumentOrganizationInfoForm$().np().ak(this$10));
  $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dInvoice$002dNumber$002dForm$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$();
  var TransformerInto_this$4 = TransformerInto_this$3.hw(this.Bs);
  var TransformerInto_this$5 = TransformerInto_this$4.hw(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(this.Br)));
  var TransformerInto_this$6 = TransformerInto_this$5.hw($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dAdditional$002dCredit$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$().ase().aP());
  var vector$macro$2 = TransformerInto_this$6.NZ.NX;
  var appdocumentdatainvoice$macro$2 = TransformerInto_this$6.NY;
  var $x_24 = vector$macro$2.O(4);
  var $x_23 = vector$macro$2.O(3);
  var $x_22 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(appdocumentdatainvoice$macro$2.Br).cs;
  var $x_21 = vector$macro$2.O(2);
  var $x_20 = vector$macro$2.O(1);
  var ev$27 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_prelude_chimney$package$$anon$3($j_app$002edata$002e$002dInvoice$002dLine$002dItem$0024.$m_Lapp_data_InvoiceLineItem$().np()).ak(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector(appdocumentdatainvoice$macro$2.F1));
  var $x_19 = ((ev$27 === null) ? null : ev$27.b0);
  var this$24 = appdocumentdatainvoice$macro$2.F2;
  if (this$24.c()) {
    var $x_18 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1 = this$24.g();
    var $x_18 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dOrigin$002dOf$002dGoods$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$().aG().ak(arg1));
  }
  var this$26 = appdocumentdatainvoice$macro$2.EZ;
  if (this$26.c()) {
    var $x_13 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1$1 = this$26.g();
    var $x_17 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$();
    var $x_16 = $j_app$002edata$002e$002dDocumentary$002dCredit$002dData$0024package$0024$002dDocumentary$002dCredit$002dNumber$002dForm$0024.$m_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$().aG().ak(arg1$1.uM);
    var $x_15 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(arg1$1.uK).cs;
    var this$30 = arg1$1.uL;
    if (this$30.c()) {
      var $x_14 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var arg1$2 = this$30.g();
      var $x_14 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dIssuing$002dBank$002dForm$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$().aG().ak(arg1$2));
    }
    var $x_13 = $x_17.as(new $j_app$002edata$002e$002dDocumentary$002dCredit$002dForm$002dData.$c_Lapp_data_DocumentaryCreditFormData($x_16, $x_15, $x_14));
  }
  var this$32 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as(appdocumentdatainvoice$macro$2.EY);
  var $x_12 = (this$32.c() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as(this$32.g()));
  var this$36 = appdocumentdatainvoice$macro$2.F6;
  if (this$36.c()) {
    var $x_11 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1$4 = this$36.g();
    var $x_11 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPlace$002dOf$002dReceipt$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfReceiptForm$().aG().ak(arg1$4));
  }
  var this$38 = appdocumentdatainvoice$macro$2.F5;
  if (this$38.c()) {
    var $x_10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1$5 = this$38.g();
    var $x_10 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPlace$002dOf$002dLoading$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$().aG().ak(arg1$5));
  }
  var this$40 = appdocumentdatainvoice$macro$2.F3;
  if (this$40.c()) {
    var $x_9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1$6 = this$40.g();
    var $x_9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPlace$002dOf$002dDelivery$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$().aG().ak(arg1$6));
  }
  var this$42 = appdocumentdatainvoice$macro$2.F4;
  if (this$42.c()) {
    var $x_8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1$7 = this$42.g();
    var $x_8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPlace$002dOf$002dDischarge$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$().aG().ak(arg1$7));
  }
  var this$44 = appdocumentdatainvoice$macro$2.F0;
  if (this$44.c()) {
    var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1$8 = this$44.g();
    var $x_7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$();
    var $x_6 = $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dIncoterm$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermForm$().aG().ak(arg1$8.BA);
    var this$46 = arg1$8.BB;
    if (this$46.c()) {
      var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var arg1$9 = this$46.g();
      var $x_5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dIncoterm$002dLocation$002dForm$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$().aG().ak(arg1$9));
    }
    var $x_4 = $x_7.as(new $j_app$002edata$002e$002dIncoterm$002dData$002dForm.$c_Lapp_data_IncotermDataForm($x_6, $x_5));
  }
  var $x_3 = vector$macro$2.O(0);
  var this$48 = appdocumentdatainvoice$macro$2.F7;
  if (this$48.c()) {
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1$10 = this$48.g();
    var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as(new $j_app$002edata$002e$002dPurchase$002dOrder$002dReference$002dForm.$c_Lapp_data_PurchaseOrderReferenceForm($j_app$002edata$002e$002dPurchase$002dOrder$002dContract$002dData$0024package$0024$002dPurchase$002dOrder$002dNumber$002dForm$0024.$m_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$().aG().ak(arg1$10.z3), arg1$10.z2));
  }
  var this$52 = appdocumentdatainvoice$macro$2.F9;
  if (this$52.c()) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1$11 = this$52.g();
    var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dTransport$002dDocument$002dNumber$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$().aG().ak(arg1$11));
  }
  return new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dCredit$002dNote$002dForm.$c_Lapp_data_AppDocumentDataCreditNoteForm($x_24, $x_23, $x_22, $x_21, $x_20, $x_19, $x_18, $x_13, $x_12, $x_11, $x_10, $x_9, $x_8, $x_4, $x_3, $x_2, $x_1);
});
function $isArrayOf_Lapp_data_AppDocumentDataInvoice(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iY)));
}
export { $isArrayOf_Lapp_data_AppDocumentDataInvoice as $isArrayOf_Lapp_data_AppDocumentDataInvoice };
var $d_Lapp_data_AppDocumentDataInvoice = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataInvoice, "app.data.AppDocumentDataInvoice", ({
  iY: 1,
  ce: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentDataInvoice as $d_Lapp_data_AppDocumentDataInvoice };
//# sourceMappingURL=app.data.-App-Document-Data-Invoice.js.map
